export var decorators = ['mentions', 'products', 'link', 'inlink'];